
export const removeDuplicateContacts = (array) => {
  return array.filter((item, i, self) => i === self.findIndex(t => (t.firstName === item.firstName && t.lastName === item.lastName && t.email === item.email)));
}

export const removeDuplicateContactsByEmail = (array) => {
  return array.filter((item, i, self) => i === self.findIndex(t => (t.email === item.email)));
}